export interface OrganizationDTO {
    id: string;
    name: string;
    inn: string;
    icon: string;
    type: number;
    directorFullName?: string;
    legalAddress?: string;
    kpp?: string;
    ogrn?: string;
    managerId?: string;
    phoneNumber?: string;
    bankAccountNumber?: string;
    correspondentAccount?: string;
    bankName?: string;
    bic?: string;
    contactPersonFullName?: string;
}

export enum OrganizationType {
    IndividualEntrepreneur = 0,
    LegalEntity = 1,
}
